import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Social Media',
  subtitle: 'Optimization',
  tagline: 'Maximize Your Organic Reach',
  icon: '🔍',
  heroDesc: 'Optimize your social media profiles and content strategy to increase organic visibility, improve discoverability, and build a strong, authentic brand presence without paid ads.',
  mainStat: '5x',
  mainStatLabel: 'Average organic reach improvement for our SMO clients',
  subStats: [{ value: '200+', label: 'Profiles Optimized' }, { value: '85%', label: 'Engagement Increase' }],
  features: [
    { icon: '🔧', title: 'Profile Optimization', desc: 'Complete audit and optimization of bio, profile picture, highlights, and links for maximum discoverability.' },
    { icon: '#️⃣', title: 'Hashtag Strategy', desc: 'Research and implementation of high-performing hashtags to boost organic post reach.' },
    { icon: '🔑', title: 'Keyword Integration', desc: 'Strategic keyword placement in captions and bios for improved searchability.' },
    { icon: '⏰', title: 'Posting Time Optimization', desc: 'Data-driven scheduling to post when your audience is most active and engaged.' },
    { icon: '📊', title: 'Engagement Analytics', desc: 'Detailed tracking of reach, impressions, and engagement to refine your strategy.' },
    { icon: '🔗', title: 'Cross-Platform Linking', desc: 'Seamless integration across all platforms to drive traffic and followers.' },
  ],
  benefits: [
    { title: 'Higher Organic Reach', desc: 'Optimized profiles and content rank higher in platform algorithms, reaching more people for free.' },
    { title: 'Better Brand Discoverability', desc: 'Proper keyword and hashtag usage makes your brand easy to find by potential customers.' },
    { title: 'Improved Credibility', desc: 'A polished, complete profile builds instant trust and professional credibility.' },
    { title: 'Long-Term Growth', desc: 'Organic growth compounds over time, giving you a sustainable, cost-effective marketing channel.' },
  ],
  process: [
    { title: 'Full Profile Audit', desc: 'Comprehensive analysis of your current profiles to identify gaps and opportunities.' },
    { title: 'Competitive Research', desc: 'Study of top competitors to uncover winning strategies in your industry.' },
    { title: 'Optimization Implementation', desc: 'Profile updates, bio rewrites, highlight creation, and keyword integration.' },
    { title: 'Content Strategy Alignment', desc: 'Aligning content format, timing, and messaging with algorithm preferences.' },
    { title: 'Monitor & Adjust', desc: 'Ongoing tracking and monthly strategy refinements based on performance data.' },
  ],
  whyChoose: [
    { icon: '🧠', title: 'Algorithm Experts', desc: 'We stay ahead of every platform algorithm update to maximize your organic reach.' },
    { icon: '🔬', title: 'Data-First Approach', desc: 'Every optimization decision is rooted in analytics, not guesswork.' },
    { icon: '📱', title: 'Platform Specialists', desc: 'Dedicated specialists for Instagram, Facebook, LinkedIn, and YouTube.' },
    { icon: '📈', title: 'Measurable Results', desc: 'Clear monthly reports showing follower growth, reach, and engagement improvements.' },
  ],
  reviews: [
    { name: 'Anjali Verma', role: 'Yoga Studio Owner', text: 'Our Instagram reach doubled in the first month. We now get organic inquiries every single day!' },
    { name: 'Suresh Pillai', role: 'Doctor', text: 'Profile optimization alone brought 30+ new patient inquiries in two months. Phenomenal.' },
    { name: 'Kavita Nair', role: 'Fashion Blogger', text: 'My engagement rate went from 1.2% to 6.8% after DMS optimized my content strategy.' },
  ],
  faq: [
    { q: 'Is SMO different from Social Media Marketing?', a: 'Yes! SMO focuses on organic growth through profile and content optimization, while SMM includes paid campaigns. Both work best together.' },
    { q: 'How long before I see results?', a: 'Most clients see measurable improvements in reach and engagement within 30–45 days of optimization.' },
    { q: 'Do you need access to our accounts?', a: 'Yes, we require admin/editor access to implement changes. All access is managed securely.' },
  ],
};

export default function SocialMediaOptimization() {
  return <ServiceTemplate data={data} />;
}
